import http from "../utils/http"

export const login = async (email: string, password: string) => {
  return http.post("/api/auth/login/", { email, password })
}

export const logout = async () => {
  return http.post("/api/auth/logout/")
}

export const getUserDetails = async () => {
  return http.get("/api/auth/user/")
}

export const resetPassword = async (email: string) => {
  return http.post("/api/auth/password/reset/", { email })
}

export const resetPasswordConfirm = async (payload: {
  uid: string
  token: string
  newPassword1: string
  newPassword2: string
}) => {
  return http.post("/api/auth/password/reset/confirm/", payload)
}

export const changePassword = async (payload: {
  // Optional: the backend runs with OLD_PASSWORD_FIELD_ENABLED off, and
  // magic-link users have no temporary password to supply.
  oldPassword?: string
  newPassword1: string
  newPassword2: string
}) => {
  return http.post("/api/auth/password/change/", payload)
}

export const register = async (userData: {
  email: string
  password1: string
  password2: string
  first_name: string
  last_name: string
  company_name: string
  company_number: string
  organisation_type: string
}) => {
  return http.post("/api/auth/registration/", userData)
}

export interface OrganisationMember {
  id: number
  email: string
  firstName: string
  lastName: string
}

export const setActivePortfolio = async (portfolioId: number): Promise<void> => {
  await http.patch("/api/core/active-portfolio/", { portfolioId })
}

export const getOrganisationMembers = async (): Promise<OrganisationMember[]> => {
  const response = await http.get("/api/core/members/")
  return response.data.members || []
}

export const requestMagicLink = async (email: string) => {
  return http.post("/api/core/magic-link/", { email })
}

export const verifyMagicLink = async (token: string) => {
  return http.post("/api/core/magic-link/verify/", { token })
}
